import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-integration',
  templateUrl: './icon-integration.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconIntegrationComponent {}
